import CloseIcon from "@assets/images/CloseModal.svg";
import SubdirectoryArrowRight from "@assets/images/SubdirectoryArrowRight.svg";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { DataItemCommon } from "@saleor/deliveryReport/views/utils/sort";
// import { GetLmsReportCsCustomerQuery } from "@saleor/graphql";
import { renderCollection } from "@saleor/misc";
import classNames from "classnames";
import React, { useMemo } from "react";
import SVG from "react-inlinesvg";
import { FormattedNumber, useIntl } from "react-intl";

import { ModalDpDetail } from "../../types";
import useStyles from "./styles";

export interface SendMailProps {
  // orderTrackingOutput: GetLmsReportCsCustomerQuery["getLmsReportCsCustomer"][0];
  dataItem: DataItemCommon[];
  open: boolean;
  onClose: () => void;
  modalInfomation: ModalDpDetail;
}

const ModalDp: React.FC<SendMailProps> = props => {
  const {
    open,
    onClose,
    // orderTrackingOutput,
    dataItem,
    modalInfomation
  } = props;
  const classes = useStyles();
  const intl = useIntl();

  const isBillingNo = useMemo(
    () => modalInfomation?.displayType === "billingNO",
    [modalInfomation]
  );

  const totalQuantity = useMemo(
    () =>
      dataItem.reduce(
        (result, currentValue) => {
          result.value += currentValue.deliveryQty;
          if (
            !result.minimumFractionDigits &&
            !Number.isInteger(currentValue?.deliveryQty)
          ) {
            result.minimumFractionDigits = 3;
            result.maximumFractionDigits = 3;
          }
          return result;
        },
        {
          value: 0,
          minimumFractionDigits: undefined,
          maximumFractionDigits: undefined
        }
      ),
    [dataItem]
  );

  const matNumberFilter = (item: DataItemCommon) => {
    if (
      item?.deliveryGrp &&
      item?.parentItemNo &&
      item?.deliveryGrp !== "000" &&
      item?.parentItemNo !== "000000"
    ) {
      const arrowIcon = SubdirectoryArrowRight;
      return (
        <div className={classes.flex}>
          <SVG
            src={arrowIcon}
            width={25}
            height={25}
            className={classes.marginRightHeader}
          />
          <span>{item.matNumber}</span>
        </div>
      );
    }

    return item.matNumber || "-";
  };

  return (
    <>
      <Dialog
        data-testid="modal-dp"
        className={classes.root}
        open={open}
        onClose={onClose}
      >
        <DialogTitle className={classes.dialogTitle}>
          <div className={classes.flexCenter}>
            <MyTypography variant={"h6"}>
              {modalInfomation?.titleModal || "-"}
            </MyTypography>
          </div>
          <SVG
            onClick={onClose}
            width={24}
            height={24}
            src={CloseIcon}
            className={classes.closeIcon}
          />
        </DialogTitle>
        <DialogContent className={classes.boxContent}>
          <div className={classes.table}>
            <Table>
              <TableHead>
                <TableRow>
                  {isBillingNo && (
                    <TableCellHeader className={classes.col7}>
                      {intl.formatMessage({ defaultMessage: "เลขที่ใบจ่าย" })}
                    </TableCellHeader>
                  )}
                  <TableCellHeader className={classes.col1}>
                    {intl.formatMessage({ defaultMessage: "เลขที่ใบสั่งซื้อ" })}
                    <MyTypography variant={"body3"}>
                      {intl.formatMessage({ defaultMessage: "(P/O)" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader className={classes.col2}>
                    {intl.formatMessage({ defaultMessage: "เลขที่ใบสั่ง" })}
                    <MyTypography variant={"body3"}>
                      {intl.formatMessage({ defaultMessage: "(S/O)" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader>
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.col3}
                    >
                      {intl.formatMessage({ defaultMessage: "รหัสสินค้า" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader>
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.col4}
                    >
                      {intl.formatMessage({ defaultMessage: "สินค้า" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader className={classes.col5}>
                    {intl.formatMessage({ defaultMessage: "จำนวน" })}
                  </TableCellHeader>
                  <TableCellHeader className={classes.col6}>
                    <MyTypography variant={"body3"}>
                      {intl.formatMessage({ defaultMessage: "หน่วย" })}
                    </MyTypography>
                  </TableCellHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {renderCollection(dataItem, (item, index) => (
                  <TableRow key={index}>
                    {isBillingNo && (
                      <TableCell>
                        <MyTypography variant={"body3"}>
                          {/* {orderTrackingOutput.dnNo} */}
                          {item.dnNo}
                        </MyTypography>
                      </TableCell>
                    )}
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item?.poNo}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item?.soNo}
                      </MyTypography>
                    </TableCell>
                    <TableCell className={classNames(classes.flexCell)}>
                      <MyTypography variant={"body3"}>
                        {matNumberFilter(item as DataItemCommon)}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item?.materialDescription}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant="body3">
                        <FormattedNumber
                          value={item.deliveryQty}
                          {...(Number.isInteger(item?.deliveryQty)
                            ? {}
                            : {
                                minimumFractionDigits: 3,
                                maximumFractionDigits: 3
                              })}
                        />
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item.saleUnit}
                      </MyTypography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              {!isBillingNo && (
                <TableHead>
                  <TableRow>
                    <TableCellHeader
                      colSpan={4}
                      className={classNames(
                        classes.totalCell,
                        classes.noBorderRight
                      )}
                    >
                      <MyTypography variant={"subtitle3"}>
                        {intl.formatMessage({ defaultMessage: "รวม:" })}
                      </MyTypography>
                    </TableCellHeader>
                    <TableCellHeader colSpan={2} className={classes.totalCell}>
                      <MyTypography variant={"subtitle3"}>
                        <FormattedNumber {...totalQuantity} />
                      </MyTypography>
                    </TableCellHeader>
                  </TableRow>
                </TableHead>
              )}
            </Table>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ModalDp;
